/**
 * isMgmShare: 我是邀請模組
 * isMgmMission: 我是任務模組
 * isMgmSelf: 我有開分享獎(我既是邀請模組也是任務模組)
 */
const getMgmFlags = (mgmConfig = {}) => {
    const mgmMapping = Array.isArray(mgmConfig) ? mgmConfig : Object.entries(mgmConfig);
    const {
        mgmShare: isMgmShare = false,
        mgmMission: isMgmMission = false,
        mgmSelf: isMgmSelf = false
    } = mgmMapping.reduce((result, [k, v]) => {
        if (mgmConfig[k] && k === 'mgmRole') {
            return { ...result, [v]: true };
        }
        return { ...result, [v]: false };
    }, {});

    return { isMgmShare, isMgmMission, isMgmSelf };
};

export default getMgmFlags;
